/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { get } from 'lodash';
import { isInt, isFloat } from 'validator';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import {
  InputAdornment,
  Box,
  TextField,
  Button,
  Autocomplete,
  Grid,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import axios from '../../services/axios';
import { Container, Title } from '../../styles/GlobalStyles';
import Loading from '../../components/Loading';
import * as actions from '../../store/modules/auth/actions';
import NumberFormatCustom from '../../utils/NumberFormatCustom';
import NumberFormatCustom3 from '../../utils/NumberFormatCustom3';

dayjs.locale('pt-br');

export default function Cadastro() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const today = dayjs();
  const { id1 } = useParams(); // id viagem
  const { id2 } = useParams(); // id receita

  const [lancamento, setLancamento] = useState(dayjs(today));
  const [descricao, setDescricao] = useState('');
  const [valor, setValor] = useState('');
  const [peso, setPeso] = useState('');
  const [comissao, setComissao] = useState('');
  const [percentual, setPercentual] = useState('');
  const [nrcoleta, setNrColeta] = useState('');
  const [id_viagem, setViagem] = useState('');
  const [id_cliente, setCliente] = useState('');
  const [id_localsaida, setIdLocalSaida] = useState('');
  const [id_localdestino, setIdLocalDestino] = useState('');
  const [datatableLocais, setDataTableLocais] = useState([]);
  const [datatableClientes, setDataTableClientes] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const textData = 'Receita';
  // const tableData = 'receita';
  const tableDatas = 'receitas';

  async function getData() {
    try {
      setIsLoading(true);

      const { data } = await axios.get(`/${tableDatas}/${id2}`);
      setDescricao(data.descricao);
      setLancamento(dayjs(data.lancamento));
      setValor(data.valor);
      setPeso(data.peso);
      setComissao(data.comissao);
      setNrColeta(data.nrcoleta);
      setViagem(data.id_viagem);
      setCliente(data.id_cliente);
      setIdLocalSaida(data.id_localsaida);
      setIdLocalDestino(data.id_localdestino);

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);

      if (status === 400) errors.map((error) => toast.error(error));
      navigate(-1);
      // navigate(`/controleviagens/${id1}/lancamento`);
    }
  }

  async function getDataDropdown() {
    try {
      setIsLoading(true);
      const { data } = await axios.get(`/viagens/${id1}`);
      const children = get(data, 'Motoristum.comissao', '');
      setPercentual(children);

      let response = await axios.get('/locais');
      setDataTableLocais(response.data);

      response = await axios.get('/clientes');
      setDataTableClientes(response.data);

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);

      if (status === 400) errors.map((error) => toast.error(error));
      navigate(-1);
      // navigate(`/controleviagens/${id1}/lancamento`);
    }
  }

  useEffect(() => {
    getDataDropdown();
    if (!id2) {
      setViagem(id1);
      return; // se não for alteração
    }
    getData();
  }, []);

  /* useEffect(() => {
    // Calcular automaticamente a comissao
    const calculo = parseFloat(valor);
    if (!Number.isNaN(calculo)) {
      setComissao(calculo * (percentual / 100));
    } else {
      setComissao('0');
    }
  }, [valor]); */

  const handleSubmit = async (e) => {
    e.preventDefault();
    let formErrors = false;

    if (!lancamento || lancamento === 'NaN') {
      toast.error('Data Lançamento inválido');
      formErrors = true;
    }

    if (!nrcoleta) {
      toast.error('O Número da Ordem de Coleta deve ser informado');
      formErrors = true;
    }

    if (!isFloat(String(valor))) {
      toast.error('Valor inválido');
      formErrors = true;
    }

    if (!isFloat(String(peso))) {
      toast.error('Peso inválido');
      formErrors = true;
    }

    if (!isFloat(String(comissao))) {
      toast.error('Comissão inválida');
      formErrors = true;
    }

    if (!isInt(String(id_cliente))) {
      toast.error(`ID do Cliente inválido`);
      formErrors = true;
    }

    if (!isInt(String(id_localsaida))) {
      toast.error(`ID do local de saída inválido`);
      formErrors = true;
    }

    if (!isInt(String(id_localdestino))) {
      toast.error('ID do local destino inválido');
      formErrors = true;
    }

    if (formErrors) return;

    try {
      setIsLoading(true);

      if (id2) {
        await axios.put(`/${tableDatas}/${id2}`, {
          lancamento,
          descricao,
          valor,
          peso,
          comissao,
          nrcoleta,
          id_viagem,
          id_cliente,
          id_localsaida,
          id_localdestino,
        });
        toast.success(`Alterado com sucesso!`);
        navigate(-1);
        // (`/controleviagens/${id1}/lancamento`);
      } else {
        await axios.post(`/${tableDatas}/`, {
          lancamento,
          descricao,
          valor,
          peso,
          comissao,
          nrcoleta,
          id_viagem,
          id_cliente,
          id_localsaida,
          id_localdestino,
        });
        toast.success(`Cadastrado com sucesso!`);
        navigate(-1);
        // navigate(`/controleviagens/${id1}/lancamento`);
      }

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const data = get(err, 'response.data', {});
      const errors = get(data, 'errors', []);

      if (errors.length > 0) {
        errors.map((error) => toast.error(error));
      } else {
        toast.error('Erro desconhecido');
      }

      if (status === 401) dispatch(actions.loginFailure());
    }
  };

  return (
    <Container>
      <Loading isLoading={isLoading} />
      <Title>{id2 ? `Alterar ${textData}` : `Nova ${textData}`}</Title>

      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          '& .MuiTextField-root': { m: 0, width: { xs: '100%', sm: '100%' } },
        }}
      >
        <Grid container spacing={1} justifyContent="center">
          <Grid item xs={12} sm={12}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="pt-br"
            >
              <DatePicker
                required
                label="Data Lançamento"
                size="small"
                value={lancamento}
                onChange={(e) => setLancamento(e)}
                format="DD/MM/YYYY"
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              required
              value={nrcoleta}
              label="Número da Ordem de Coleta"
              size="small"
              onChange={(e) => setNrColeta(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              required
              value={valor}
              label="Valor"
              size="small"
              onChange={(e) => setValor(e.target.value)}
              onBlur={() => {
                const calculo = parseFloat(valor);
                if (!Number.isNaN(calculo)) {
                  setComissao(calculo * (percentual / 100));
                } else {
                  setComissao('0');
                }
              }}
              InputProps={{
                inputComponent: NumberFormatCustom,
                startAdornment: (
                  <InputAdornment position="start">R$</InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              required
              value={peso}
              label="Peso Transportado"
              size="small"
              onChange={(e) => setPeso(e.target.value)}
              InputProps={{
                inputComponent: NumberFormatCustom3,
                startAdornment: (
                  <InputAdornment position="start">T</InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              value={comissao}
              label="Comissão do Motorista"
              size="small"
              InputProps={{
                inputComponent: NumberFormatCustom,
                startAdornment: (
                  <InputAdornment position="start">R$</InputAdornment>
                ),
                readOnly: true,
                tabIndex: -1,
                // Prevenir o foco
                inputProps: {
                  onFocus: (event) => event.target.blur(),
                },
              }}
              variant="filled"
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              id={id_cliente}
              value={
                datatableClientes.find((option) => option.id === id_cliente) ||
                null
              }
              options={datatableClientes}
              getOptionLabel={(option) => option.nome}
              onChange={(event, newValue) => {
                setCliente(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  required
                  label="Cliente"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              id={id_localsaida}
              value={
                datatableLocais.find((option) => option.id === id_localsaida) ||
                null
              }
              options={datatableLocais}
              getOptionLabel={(option) => `${option.municipio} / ${option.uf}`}
              onChange={(event, newValue) => {
                setIdLocalSaida(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  required
                  label="Local Saída"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              id={id_localdestino}
              value={
                datatableLocais.find(
                  (option) => option.id === id_localdestino
                ) || null
              }
              options={datatableLocais}
              getOptionLabel={(option) => `${option.municipio} / ${option.uf}`}
              onChange={(event, newValue) => {
                setIdLocalDestino(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  required
                  label="Local Destino"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              value={descricao}
              label="Descrição"
              size="small"
              onChange={(e) => setDescricao(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              type="button"
              color="secondary"
              variant="contained"
              onClick={handleSubmit}
            >
              {id2 ? 'Alterar' : 'Cadastrar'}
            </Button>
            <Button
              type="button"
              onClick={() => navigate(-1)}
              // onClick={() => navigate(`/controleviagens/${id1}/lancamento`)}
            >
              Cancelar
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}
